import { csx, style, styleVariants } from '@vtex/admin-ui'

export const comboboxItem = csx({
  textAlign: 'start',
  padding: '$space-2 $space-3',
  bg: '$action.neutral.tertiary',
  cursor: 'pointer',
  borderRadius: '$base',
  textWrap: 'nowrap',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  pointerEvents: 'all !important',
  ':hover': {
    bg: '$action.neutral.tertiaryHover',
    '.show-on-hover': {
      opacity: '.7',
    },
    '.hide-on-hover': {
      display: 'none',
    },
  },
  '&[aria-selected="true"]': {
    bg: '$action.neutral.tertiaryHover',
  },
  '&[data-focus-visible]': {
    bg: '$action.neutral.tertiaryHover',
  },
})

export const selectedItemVariant = styleVariants({
  selected: {
    true: {
      '> span:first-child': {
        fg: '$secondary',
      },
      fg: '$action.main.tertiarySelected',
    },
    false: {
      '> span:first-child': {
        fg: '$secondary',
      },
      fg: 'currentColor',
    },
  },
})

export const textSearch = csx({
  color: '$secondary',
})

export const value = csx({
  color: '$primary',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const searchingBy = style({
  borderRadius: '$base',
  backgroundColor: 'rgba(0, 0, 0, 0.05)',
  color: '$primary',
  display: 'inline-block',
  fontWeight: 'normal',
  padding: '$space-1 0.375rem',
  whiteSpace: 'nowrap',
})

export const pinButton = csx({
  color: '$black',
  padding: '0 !important',
  width: '24px',
  height: '24px !important',
  textAlign: 'center',
  opacity: 0,
  '&.show': {
    opacity: '1',
    '.dashed-pin': {
      display: 'none',
    },
    '&:hover': {
      '.fullfield-pin': {
        display: 'none',
      },
    },
  },
  '&:hover': {
    opacity: '1 !important',
    '.dashed-pin': {
      display: 'block',
    },
  },
  svg: {
    margin: '0 !important',
  },
})
